export const FETCH_ALL_RADIOLOGISTS = "[RECEPTIONIST] FETCH_ALL_RADIOLOGISTS";
export const FETCH_ALL_RADIOLOGISTS_START = "[RECEPTIONIST] FETCH_ALL_RADIOLOGISTS_START";
export const FETCH_ALL_RADIOLOGISTS_SUCCESS = "[RECEPTIONIST] FETCH_ALL_RADIOLOGISTS_SUCCESS";
export const FETCH_ALL_RADIOLOGISTS_ERROR = "[RECEPTIONIST] FETCH_ALL_RADIOLOGISTS_ERROR";



export const fetchAllRadiologists = () => {
    return {
        type: FETCH_ALL_RADIOLOGISTS,
        payload: null
    }
}